"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var handleDetermineLink_1 = __importDefault(require("./handleDetermineLink"));
var useStyles = core_1.makeStyles(function (theme) {
    var _a;
    return ({
        root: (_a = {
                flexDirection: 'column'
            },
            _a[theme.breakpoints.up('sm')] = {
                flexDirection: 'row',
            },
            _a)
    });
});
var BasicMenuLinks = function (_a) {
    var links = _a.links, children = _a.children;
    var classes = useStyles();
    return (react_1.default.createElement(core_1.Box, { display: 'flex', className: classes.root },
        links.map(handleDetermineLink_1.default),
        children));
};
exports.default = BasicMenuLinks;
